import { getFontSizes } from './helper';

export const goibiboTheme = {
  colors: {
    base: {
      primary: 'var(--color-primary)',
      secondary: '',
    },
    text: {
      primary: '#000',
      secondary: '',
    },
    button: {
      primary: {
        bg: 'var(--color-btn-primary-bg)',
        text: 'var(--color-btn-primary-text)',
        border: 'var(--color-btn-primary-bg)',
        color: 'var(--color-btn-primary-bg)',
        bg2: '',
      },
      updateBtn: {
        bg: 'var(--color-btn-primary-bg)',
      },
      secondary: {
        bg: '#ffffff',
        text: '#16a085',
      },
      topNav: {
        bg: '#ffffff',
        text: '#000000',
      },
    },
    label: {
      primary: '#ffffff',
      secondary: '',
    },
    link: {
      primary: 'var(--color-primary)',
      secondary: '#42925C',
    },
    slider: {
      track: 'var(--color-primary)',
    },
    topNav: 'var(--color-primary)',
    overlays: {
      topNavForm: 'rgba(0, 0, 0, 0.3)',
    },
    bodyBG: '#EFF4FC',
    bodyBGListing: '#EFF4FC',
  },
  font: {
    urls: [
      'https://fonts.googleapis.com/css?family=Quicksand:300,400,400i,700,900&display=swap',
      '/holidays/node/fonts/Helvetica/Helvetica.css',
    ],
    family: 'Helvetica Neue',
    size: {
      main: getFontSizes(),
      pageHeader: '40px',
      heading: '32px',
      subHeading: '16px',
      button: getFontSizes('12px', '16px', '18px', '20px'),
    },
    weight: '900',
    headings: {
      fontFamily: "'Quicksand', sans-serif",
    },
  },
  images: {
    logo: '',
    mainBg: '',
    favicon: 'https://jsak.mmtcdn.com/holidays/node/images/common/gi_logo.ico',
  },
  radius: {},
  cards: {
    destinationInfo: {
      fontSize: '16px',
    },
  },

  detailsPage: {
    leftContainer: {
      boxShadow: 'none',
    },
    mainNav: {
      fontSize: '14px',
      fontWeight: '900',
    },
    itineraryNav: {
      bgColor: '#ffffff',
      marginBottom: '12px',
      tab: {
        color: '#4a4a4a',
        bgColor: 'transparent',
        active: {
          bgColor: 'var(--color-primary)',
          color: '#ffffff',
        },
      },
    },
    dayplan: {
      bgColor: '#ffffff',
      title: {
        bg: 'linear-gradient(87deg, #f4d1ca 15%, #e2d9b2 100%)',
        bg2: 'linear-gradient(85.23deg, #FF7F3F 0%, #FF3E5E 100%);',
      },
      flightUpgradeRow: {
        bg: '#EAF5FF',
        margin: '10px 0 0',
        borderRadius: '0',
      },
    },
    rightContainer: {
      topHeader: {
        bg: '#EAF5FF',
        badge: {
          bg: '#FF3A5C',
        },
      },
    },
  },
  thankyouPage: {
    topHeaderColor: '#FFF',
    bg: 'linear-gradient(238.38deg, #1B9564, #39D546)',
  },
  reviewPage: {
    bgColor: 'var(--color-primary)',
    navColor: '#FFFFFF',
  },
};
